import { MenuItemData } from '@components/Navigation/types';
import { mc, StyleProps } from '@styles';
import React, { FC, useState } from 'react';

import MobileDropdownBackBtn from '../BackBtn';
import ChevroneDownIcon from './assets/chevronDown.inline.svg';
import ChevroneUpIcon from './assets/chevronUp.inline.svg';

interface Props extends StyleProps {
  item: MenuItemData;
  onLinkClick?: () => void;
  onGoBack?: () => void;
}

export const MobileTreeViewMenu: FC<Props> = ({ className, item, onLinkClick, onGoBack }) => {
  const [selected, setSelected] = useState<MenuItemData | undefined>(undefined);
  const { items = [] } = item;

  const isSelected = (itm: MenuItemData) => itm.title === selected?.title;

  return (
    <div className={mc(className)}>
      <MobileDropdownBackBtn className={mc('w-full')} onClick={onGoBack}>
        {item.title}
      </MobileDropdownBackBtn>
      <div
        className={mc('px-8 py-2.5', 'text-lg italic font-raleway leading-normal tracking-wide font-semibold text-ocean-blue')}
      >
        {'Discover'}
      </div>
      {items.map(subitm => (
        <div key={subitm.title} className="mb-2.5">
          <button
            className={mc(
              'px-7 py-2 w-full',
              'flex flex-row justify-between items-center',
              isSelected(subitm) && 'bg-light-gray',
              isSelected(subitm) ? 'text-salmon' : 'text-ocean-blue',
            )}
            role="button"
            onClick={() => setSelected(subitm.title === selected?.title ? undefined : subitm)}
          >
            <span className={mc('inline-block', 'text-2xl font-raleway leading-normal', 'capitalize')}>{subitm.title}</span>
            {isSelected(subitm) ? <ChevroneUpIcon className="inline-block" /> : <ChevroneDownIcon className="inline-block" />}
          </button>
          {isSelected(subitm) && (
            <div className="px-8 py-6 bg-light-gray">
              {!!subitm.subtitle && (
                <div
                  className={mc(
                    'pl-5 w-full',
                    'text-lg italic font-raleway leading-normal tracking-wide font-semibold text-ocean-blue',
                  )}
                >
                  {subitm.subtitle}
                </div>
              )}
              {subitm.items?.map(itm => (
                <a
                  key={itm.title}
                  href={itm.url || '#'}
                  className={mc(
                    'block',
                    'pl-5 py-2 mt-2.5 w-full',
                    'text-2xl font-raleway leading-normal text-primary-ocean-blue',
                  )}
                  onClick={onLinkClick}
                >
                  {itm.title}
                </a>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export type MobileTreeViewMenuProps = Props;
export default MobileTreeViewMenu;
